

// 保证全局事件总线存在
if (!window.starryEventBus) {
  window.starryEventBus = {
    _events: {},
    on(event, handler) {
      (this._events[event] = this._events[event] || []).push(handler);
    },
    emit(event, ...args) {
      (this._events[event] || []).forEach((fn) => fn(...args));
    },
    off(event, handler) {
      if (!this._events[event]) return;
      this._events[event] = this._events[event].filter((fn) => fn !== handler);
    },
  };
}

// 资源加载相关函数和变量
const starryAssets = {
  js: {
    urls: window.ro_starryScriptURLs,
    load: starryLoadJS,
  },
  css: {
    urls: window.ro_starryStyleURLs,
    load: starryLoadCSS,
  },
  oldcss: {
    urls: window.ro_starryOldStyleURLs,
    load: starryLoadCSS,
  },
};
function starryLoadJS(src) {
  let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
  let async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let defer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}
function starryLoadCSS(href) {
  let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.head;
  // 增加健壮性判断
  if (!target || typeof target.appendChild !== 'function') {
    target = document.head;
  }
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}
function starryLoadAssets(param) {
  for (
    var _len = arguments.length,
      rest = new Array(_len > 1 ? _len - 1 : 0),
      _key = 1;
    _key < _len;
    _key++
  ) {
    rest[_key - 1] = arguments[_key];
  }
  return new Promise((resolve, reject) => {
    const files = typeof param === "string" ? [param] : param;
    Promise.all(
      files.map(async (file) => {
        try {
          const [, name, type] = file.match(/(.*)\.(js|css)$/) || [, file, 'js'];
          let configType = type;
          if(name === 'swiper-bundle.min'){
            configType = 'oldcss'
          }
          const { urls, load } = starryAssets[configType];
          // 检查是否是 swiper-bundle.min.js，如果页面已引入 swiper.min.js，则跳过加载
          // if (name === 'ro-swiper-bundle.min' && type === 'js') {
          //   if (document.querySelector('script[src*="swiper.min.js"]')) {
          //     console.log('已检测到页面引入了 swiper.min.js，跳过加载 swiper-bundle.min.js');
          //     return;
          //   }
          // }
 

          const assetUrl = (urls && urls[name] && urls[name].url) || `/assets/${name}.${type}`;
          await load(assetUrl, ...rest);
          console.log(`${name}.${type}`);
        } catch (err) {
          console.warn(`Failed to load asset: ${file}.`, err);
        }
      })
    )
      .then(resolve)
      .catch(reject);
  });
}

(function () {
  if (window.__starrySwiperLoaderInitialized) return;
  window.__starrySwiperLoaderInitialized = true;

  document.addEventListener("DOMContentLoaded", () => {
    // 懒加载 swiper 资源
    // 页面加载完后再去获取元素，避免因脚本执行过早导致获取不到元素
    const swiperTriggers = document.querySelectorAll('.starry-swiper-trigger');
    if (!swiperTriggers.length) return;

    let swiperAssetsLoaded = false;
    const swiperObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!swiperAssetsLoaded) {
            swiperAssetsLoaded = true;
            // 检查页面是否已引入 swiper.min.js，如果有则不加载 swiper-bundle.min.js
            const hasSwiperMin = document.querySelector('script[src*="swiper-bundle.min.js"]');
            if (!hasSwiperMin) {
              // 只在没有 swiper.min.js 时才加载新版样式和脚本
              starryLoadAssets(["ro-swiper-bundle.min.css", "ro-swiper-bundle.min.js"]).then(() => {
                window.starryEventBus.emit("roInitStarrySwiper");
              });
            } else {
              starryLoadAssets(["swiper-bundle.min.css"]).then(() => {
                console.log('已有 swiper.min.js，不加载任何新版 Swiper 资源');
                window.starryEventBus.emit("roInitStarrySwiper");
              });
            }
          }
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px 150px 0px',
    });
    swiperTriggers.forEach(trigger => swiperObserver.observe(trigger));
  });
})();
